import React from 'react';
import { Loader2 } from 'lucide-react';

interface Props {
  mensagem?: string;
}

/**
 * ComponenteCarregamento
 *
 * Spinner simples centralizado com mensagem. Reutilizável em toda a aplicação
 */
export default function ComponenteCarregamento({ mensagem = 'Carregando...' }: Props) {
  return (
    <div className="flex min-h-[200px] items-center justify-center">
      <div className="text-center">
        <Loader2 className="mx-auto size-8 animate-spin text-gray-600" />
        <p className="mt-2 text-sm text-gray-600">{mensagem}</p>
      </div>
    </div>
  );
}
